import { Progress } from '@/components/ui/progress';
import { AppProductTypeEnum } from 'src/graphql/schema';
import { productTypeMap } from 'src/shared/mappings/productTypeMap';
import { cn } from 'src/lib/utils';

type Props = {
  currentStep: number;
  totalSteps: number;
  productType?: AppProductTypeEnum;
};

const PRODUCT_ACCENT_CLASS: Record<AppProductTypeEnum, { text: string; progress: string }> = {
  [AppProductTypeEnum.SoftwareEscrow]: {
    text: 'text-accent-software-escrow',
    progress: '*:data-[slot=progress-indicator]:bg-accent-software-escrow',
  },
  [AppProductTypeEnum.SaasEscrow]: {
    text: 'text-accent-saas-escrow',
    progress: '*:data-[slot=progress-indicator]:bg-accent-saas-escrow',
  },
  [AppProductTypeEnum.ContinuityEscrow]: {
    text: 'text-accent-continuity-escrow',
    progress: '*:data-[slot=progress-indicator]:bg-accent-continuity-escrow',
  },
  [AppProductTypeEnum.Backup]: {
    text: 'text-accent-software-backup',
    progress: '*:data-[slot=progress-indicator]:bg-accent-software-backup',
  },
  [AppProductTypeEnum.CustodianProfile]: {
    text: 'text-accent-software-custodian',
    progress: '*:data-[slot=progress-indicator]:bg-accent-software-custodian',
  },
};

const ProtectionType = ({ productType }: { productType: AppProductTypeEnum }) => {
  const { label, icon: Icon } = productTypeMap[productType];

  return (
    <div data-slot="protection-type" className={cn('flex items-center gap-2', PRODUCT_ACCENT_CLASS[productType].text)}>
      <Icon className="size-4.5 shrink-0" />
      <span className="text-xs font-semibold uppercase tracking-[0.04em]">{label}</span>
    </div>
  );
};

const SoftwareOnboardingProgress = ({ currentStep, totalSteps, productType }: Props) => {
  return (
    <div className="flex grow flex-col gap-5">
      <div className="flex items-center gap-3">
        <span className="shrink-0 text-xs font-semibold text-muted-foreground">
          Step {currentStep} of {totalSteps}
        </span>
        <Progress
          value={(currentStep / totalSteps) * 100}
          className={cn(
            'h-1 grow bg-gray-200 *:data-[slot=progress-indicator]:duration-300',
            PRODUCT_ACCENT_CLASS[productType ?? AppProductTypeEnum.SoftwareEscrow].progress,
          )}
        />
      </div>
      {productType && <ProtectionType productType={productType} />}
    </div>
  );
};

export { SoftwareOnboardingProgress };
